<div class="loading-wrapper">
  <img class="ff-logo" src="assets/images/svg/fagforbundet-logo-rgb.webp" alt="Fagforbundet logo" />
  <mat-progress-spinner class="ff-loader" mode="indeterminate" diameter="80" color="primary"></mat-progress-spinner>
  <p class="loading-text">{{ message$ | async }}</p>
</div>
